(() => {
  function init(root) {
    if (!root || root.dataset.shReady) return;
    root.dataset.shReady = 'true';
    const input = root.querySelector('#sh-search');
    const cards = [...root.querySelectorAll('[data-sh-record]')];
    const filters = [...root.querySelectorAll('[data-sh-filter]')];
    const count = root.querySelector('[data-sh-count]');
    const noun = count.textContent.replace(/^\d+\s*/, '');
    let category = 'All';
    function update() {
      const terms = input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
      let visible = 0;
      cards.forEach(card => {
        card.hidden = !(category === 'All' || card.dataset.category === category) || !terms.every(term => card.dataset.search.toLocaleLowerCase().includes(term));
        if (!card.hidden) visible++;
      });
      count.textContent = `${visible} / ${cards.length} ${noun}`;
      root.querySelector('[data-sh-empty]').hidden = visible !== 0;
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.shFilter === category)));
    }
    input.addEventListener('input', update);
    filters.forEach(button => button.addEventListener('click', () => {category = button.dataset.shFilter; update();}));
    root.querySelector('[data-sh-reset]').addEventListener('click', () => {category = 'All'; input.value = ''; update(); input.focus();});
    const finder = root.querySelector('#sh-find');
    const findInput = root.querySelector('#sh-find-query');
    const findKind = root.querySelector('#sh-find-kind');
    const findStatus = root.querySelector('[data-sh-find-status]');
    const findResults = root.querySelector('[data-sh-find-results]');
    const normalize = text => text.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase().replace(/[’']/g, '');
    const groups = [
      ['people', '.sh-person, .sh-cast-credit'],
      ['objects', '.sh-record, .sh-world>article'],
      ['craft', '.sh-document, .sh-production-group>details, .sh-craft-record, .sh-chronology>article, .sh-checks>article, .sh-editions>article, .sh-campaign>article, .sh-viewing>div>article'],
      ['readings', '.sh-study-grid>article, .sh-arguments article, .sh-debates>article, .sh-reception>div>article, .sh-comparisons>article'],
      ['sources', '.sh-sources>details']
    ];
    const entries = groups.flatMap(([kind, selector]) => [...root.querySelectorAll(selector)].filter(node => node.id).map(node => ({
      node, kind, id: node.id,
      title: node.querySelector('h3, h4')?.textContent.trim() || (node.matches('tr') ? [...node.cells].slice(0, 2).map(cell => cell.textContent.trim()).join(' / ') : node.id),
      text: normalize(node.textContent + ' ' + node.id.replace(/-/g, ' '))
    })));
    function find() {
      const terms = normalize(findInput.value).trim().split(/\s+/).filter(Boolean);
      findResults.replaceChildren();
      if (!terms.length && findKind.value === 'all') {findStatus.textContent = findStatus.dataset.ready; return;}
      const matches = entries.filter(entry => (findKind.value === 'all' || entry.kind === findKind.value) && terms.every(term => entry.text.includes(term)));
      findStatus.textContent = matches.length ? `${matches.length} ${matches.length === 1 ? findStatus.dataset.match : findStatus.dataset.matches}` : findStatus.dataset.none;
      const fragment = document.createDocumentFragment();
      matches.forEach(entry => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        const type = document.createElement('span');
        type.textContent = findKind.querySelector(`option[value="${entry.kind}"]`).textContent;
        a.href = '#' + entry.id; a.append(type, document.createTextNode(entry.title + ' ↗'));
        li.append(a); fragment.append(li);
      });
      findResults.append(fragment);
    }
    if (finder) {
      finder.hidden = false;
      findInput.addEventListener('input', find);
      findKind.addEventListener('change', find);
      root.querySelector('[data-sh-find-reset]').addEventListener('click', () => {findInput.value = ''; findKind.value = 'all'; find(); findInput.focus();});
      const uses = new Map();
      entries.filter(entry => entry.kind !== 'sources').forEach(entry => {
        entry.node.querySelectorAll('.sh-source a[href^="#sh-S"]').forEach(link => {
          const id = link.getAttribute('href').slice(1);
          if (!uses.has(id)) uses.set(id, new Map());
          uses.get(id).set(entry.id, entry);
        });
      });
      const template = root.querySelector('#sh-source-backlinks');
      root.querySelectorAll('.sh-sources>details').forEach(source => {
        const references = uses.get(source.id);
        if (!references?.size) return;
        const block = template.content.firstElementChild.cloneNode(true);
        references.forEach(entry => {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = '#' + entry.id; a.textContent = entry.title + ' ↗';
          li.append(a); block.querySelector('ul').append(li);
        });
        source.append(block);
      });
    }
    const dialog = root.querySelector('.sh-lightbox');
    let opener;
    root.querySelectorAll('[data-sh-zoom]').forEach(link => link.addEventListener('click', event => {
      if (typeof dialog.showModal !== 'function') return;
      event.preventDefault(); opener = link;
      const image = dialog.querySelector('img');
      image.src = link.href; image.alt = link.querySelector('img').alt;
      dialog.querySelector('p').textContent = link.closest('figure').querySelector('figcaption').textContent;
      dialog.showModal();
    }));
    dialog.addEventListener('close', () => opener?.focus());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const b = dialog.getBoundingClientRect();
      if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) dialog.close();
    });
    function reveal(hash = location.hash, focus = false) {
      let id;
      try {id = decodeURIComponent(hash.slice(1));} catch {return;}
      if (!id.startsWith('sh-')) return;
      const target = document.getElementById(id);
      if (!target || !root.contains(target)) return;
      const card = target.closest('[data-sh-record]');
      if (card?.hidden) {category = 'All'; input.value = ''; update();}
      for (let parent = target; parent && parent !== root; parent = parent.parentElement) {
        if (parent.tagName === 'DETAILS') parent.open = true;
      }
      if (target.matches('.sh-record, .sh-world>article, .sh-study-grid>article, .sh-person')) {
        const detail = target.querySelector('details');
        if (detail) detail.open = true;
      }
      if (focus) {
        target.setAttribute('tabindex', '-1');
        target.focus({preventScroll: true});
        target.scrollIntoView({block: 'start'});
      }
    }
    root.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!link || link.target === '_blank') return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash.startsWith('#sh-')) return;
      event.preventDefault();
      history.pushState(null, '', url.hash);
      reveal(url.hash, true);
    });
    window.addEventListener('hashchange', () => reveal(location.hash, true));
    window.addEventListener('popstate', () => reveal(location.hash, true));
    reveal(location.hash, Boolean(location.hash));
  }
  document.querySelectorAll('.sh-dossier').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('.sh-dossier')));
})();
